import * as msal from "msal";
import {setClientToken} from './axios'
const myMSALObj = new msal.UserAgentApplication({
  auth: {
    clientId: "343ed40a-80a3-43e8-84a8-d7f9c18fcf0a",
    redirectUri:'http://localhost:3000/auth/callback'//'https://admin.vhu.edu.vn/auth/callback',//'https://tripleh.vn/azure'
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
});

const option = {scopes: ["api://343ed40a-80a3-43e8-84a8-d7f9c18fcf0a/User.read"]}
const optionRefesh = {
  scopes: ["api://343ed40a-80a3-43e8-84a8-d7f9c18fcf0a/User.read"],
  forceRefresh: true
}

export const getToken = () => {
  if (myMSALObj.getAccount()) {
    myMSALObj.acquireTokenSilent(option)
        .then(response => {
          sessionStorage.setItem("Access_Token", response.accessToken);
          sessionStorage.setItem("ExpireIn", response.expiresOn);
          setClientToken(response.accessToken)
        })
        .catch(err => {
          if (err.name === "InteractionRequiredAuthError") {
            return myMSALObj.acquireTokenPopup(option)
                .then(response => {

                })
                .catch(err => {

                });
            }
        });
} else {
  myMSALObj.loginPopup(option)
  .then(loginResponse => {
    getToken()
  }).catch(error => {
    console.error(error);
  });
}
}

export const getAccessToken = () => {
  if (myMSALObj.getAccount()) {
    myMSALObj.acquireTokenSilent(optionRefesh)
      .then(response => {
        sessionStorage.setItem("Access_Token", response.accessToken);
        sessionStorage.setItem("ExpireIn", response.expiresOn);
        return response.accessToken
      })
  }
}

export const SignIn = (history) =>{
  myMSALObj.loginPopup(option)
  .then(loginResponse => {
    if (myMSALObj.getAccount()) {
      console.log(myMSALObj.getAccount())
      myMSALObj.acquireTokenSilent(option) 
      .then(response => {
        sessionStorage.setItem("Access_Token", response.accessToken);
        sessionStorage.setItem("ExpireIn", response.expiresOn);
        setClientToken(response.accessToken)
        history.push('/dashboard')
      })
    }
  }).catch(error => {
    console.error(error);
  });
}


// WEBPACK FOOTER //
// ./src/actions/msal.js